import { Component, Input, ViewChild, inject } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { I18NextPipe } from 'angular-i18next';

import { ButtonComponent, CheckboxComponent, ModalComponent, ModalFooterDirective } from 'mbs-ui-kit';

import { CommonModule } from '@angular/common';

@UntilDestroy()
@Component({
  selector: 'mbs-checkbox-legend',
  templateUrl: './checkbox-legend.component.html',
  styleUrls: ['./checkbox-legend.component.scss'],
  imports: [ButtonComponent, CheckboxComponent, CommonModule, ModalComponent, I18NextPipe, ModalFooterDirective]
})
export class CheckboxLegendComponent {
  private i18nPipe = inject(I18NextPipe);

  @Input() title = this.i18nPipe.transform('wizards:legendTitle', { format: 'title' });
  @Input() isRestore = false;

  @ViewChild(ModalComponent, { static: true }) baseModal: ModalComponent;

  close(): void {
    this.baseModal.close();
  }
}
